import { LOADING } from "../../../constants/constant";
import {
    GET_APPROVED_AGGREGATORS_FOR_CARRIER,
    GET_APPROVED_AGGREGATORS_FOR_CARRIER_SUCCESS,
    GET_APPROVED_AGGREGATORS_FOR_CARRIER_FAILED,
    GET_APPROVED_AGGREGATORS_FOR_CARRIER_RESET,
} from "../../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: true,
};

export default function getApprovedAggregatorsForCarrierReducer(state = initialState, action) {
  switch (action.type) {
    case GET_APPROVED_AGGREGATORS_FOR_CARRIER: {
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      return reqstState;
    }

    case GET_APPROVED_AGGREGATORS_FOR_CARRIER_SUCCESS: {
      let userRes = Object.assign({}, state);
      console.log(
        "getApprovedAggregatorsForCarrierReducer => Case => Success: while getting Approved aggregators list: " +
          JSON.stringify(action.data)
      );
      userRes.status = action.data.status_message;
      userRes.statusCode = action.data.status_code;
      userRes.isLoading = false;
      userRes.aggregators = action.data.data;

      return userRes;
    }
    case GET_APPROVED_AGGREGATORS_FOR_CARRIER_FAILED: {
      console.error(
        "getApprovedAggregatorsForCarrierReducer => Case => Error: while getting Approved aggregators list: " +
          JSON.stringify(action.error)
      );
      return Object.assign({}, state, action.error);
    }

    case GET_APPROVED_AGGREGATORS_FOR_CARRIER_RESET: {
      return initialState;
    }

    default:
      return state;
  }
}